<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t(`${abrev}-safra`) }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isAgro ? $t('agro') : $t('vendas')
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{
                                        isAgro ? $t('agro-cadastros') : $t('crm')
                                    }}</a>
                                </li>
                                <li v-if="this.$route.query.tela">
                                    <a class="a-inativo">
                                        {{ $t('agro-niveltecnologico') }}
                                    </a>
                                </li>
                                <li v-else>
                                    <a @click="$router.push({ name: `${abrev}-safra-list` })">{{
                                        $t(`${abrev}-safra`)
                                    }}</a>
                                </li>
                                <li v-if="this.$route.query.tela">
                                    <a @click="redirectToList()">
                                        {{ $t('novo-nivel-tecnologico') }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id ? $route.params.descricao : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="this.$route.query.tela"
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToList"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-else
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: `${abrev}-safra` })"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="allowedUpdate || allowedCreate"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="'codigo'"
                                ref="idsafraerpInput"
                                v-model="safra.idsafraerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                :required="isUpdate"
                                :invalid="isUpdate && isNull(safra.idsafraerp)"    
                                :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                            />
                        </div>
                        <div class="column is-8">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="safra.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :invalid="safra.descricao == null || safra.descricao == ''"
                                :required="true"
                                tooltipLabel="informacao-agro-safra-descricao"
                                tooltipSize="is-small"
                                :disabled="cantEdit || (!allowedUpdate && !allowedCreate)"
                            />
                        </div>
                        <div class="column is-2">
                            <label for="situacao" v-text="$t('situacao')" />
                            <vss-select
                                :id="generateId(2)"
                                ref="situacaoInput"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="cantEdit || (!allowedUpdate && !allowedCreate)"
                            />
                        </div>
                        <!-- Data Inicio-->
                        <div class="column is-6">
                            <verified-date-picker
                                :id="generateId(3)"
                                ref="datainicialInput"
                                placeholder="selecione-uma-data"
                                dateType="startDate"
                                v-model="datainicial"
                                :endDate="
                                    datafinal == null
                                        ? $moment().add(2, 'years').toDate()
                                        : datafinal
                                "
                                :required="true"
                                :addDateYears="2"
                                title="data-inicial"
                                :inForm="true"
                                :showToday="false"
                                :showClean="false"
                                tooltipLabel="data-ini-safra-inf"
                                tooltipSize="is-small"
                                :invalid="datainicial == null"
                                :disabled="cantEdit || (!allowedUpdate && !allowedCreate)"
                            />
                        </div>
                        <!-- Data Fim-->
                        <div class="column is-6">
                            <verified-date-picker
                                :id="generateId(4)"
                                placeholder="selecione-uma-data"
                                dateType="endDate"
                                v-model="datafinal"
                                :startDate="datainicial"
                                :addDateYears="2"
                                title="data-final"
                                :inForm="true"
                                :showToday="false"
                                :showClean="true"
                                tooltipLabel="data-fim-safra-inf"
                                tooltipSize="is-small"
                                :disabled="cantEdit || (!allowedUpdate && !allowedCreate)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//Service
import SafraService from '@/services/agro/SafraService';
//Validation
import SafraValidation from '@/services/validations/SafraValidation';
//COMPONENTS
import Message from '@/models/Message';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';
import { TheMask } from 'vue-the-mask';

export default {
    components: {
        TheMask,
        HideInfo,
    },
    data() {
        return {
            safraIntegracao: this.$store.state.user.tabelasERPWebServer.includes('AGRO_SAFRA'),
            service: new SafraService(this.$http, this.$router),
            validations: new SafraValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            safra: {
                id: null,
                idsafraerp: null,
                codigo: null,
                descricao: null,
                datainicial: null,
                datafinal: null,
                situacao: null,
            },
            isUpdate: false,
            cantEdit: false,
            datainicial: new Date(),
            datafinal: null,
            allowedCreate: false,
            allowedUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },

            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
            originalIdErp: ''
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-safra');
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-safra');
        }

        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: `${this.abrev}-safra` },
            });
        } else {
            this.allowedCreate = !this.isUpdate && this.permissao.create && !this.safraIntegracao;

            this.allowedUpdate = this.isUpdate && this.permissao.update && !this.safraIntegracao;

            if (this.isUpdate) {
                this.carregarDados();
                this.cantEdit = !this.permissao.update;
            } else {
                // para carregar o  carregar o campo situacao
                this.situacoes[this.situacao];
            }
        }
    },
    computed: {
        ...mapState(['hide']),
    },

    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados() {
            this.isLoading = true;
            this.service
                .find(this.$route.params.id, this.abrev)
                .then((value) => {
                    this.safra = Object.assign({}, value.content);
                    this.originalIdErp = this.safra.idsafraerp;
                    this.situacao = this.situacoes[this.safra.situacao];
                    if (this.safra.datainicial != null)
                        this.datainicial = this.$moment(this.safra.datainicial).toDate();
                    if (this.safra.datafinal != null)
                        this.datafinal = this.$moment(this.safra.datafinal).toDate();
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        mapItems(body) {
            let list = body.content.map((i) => {
                return {
                    id: i.idsafra,
                    label: i.descricao,
                    situacao: i.situacao,
                };
            });
            return list;
        },
        save() {
            this.isLoading = true;
            this.safra.datainicial =
                this.datainicial != null
                    ? this.$moment(this.datainicial).format('YYYY-MM-DD')
                    : null;
            if (this.validations.validate(this.safra, this.$refs)) {
                if(this.isPrefixSovisInIdErpInvalid(this.safra.idsafraerp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';
            
                    this.isLoading = false;

                    return this.$root.showMessage('alert', message, true);
                }

                let safraTemp = Object.assign({}, this.safra);
                safraTemp = this.mapTosave(safraTemp);
                safraTemp.situacao = this.situacao.id;
                safraTemp.datafinal =
                    this.datafinal != null
                        ? this.$moment(this.datafinal).format('YYYY-MM-DD')
                        : null;
                this.invalidIcon = false;
                this.isSaving = true;
                this.service
                    .save(safraTemp, this.abrev)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-agro-safra';
                            if (this.safra.idsafra != null) {
                                msg = 'msg-edit-agro-safra';
                            }
                            this.safra = Object.assign({}, value.content);
                            this.originalIdErp = this.safra.idsafraerp;
                            this.msgs.push(new Message('success', msg, true));
                            this.redirectToPage();
                            this.isUpdate = true;
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (this.$te(e.body.message)) {
                            if (e.body.message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(e.body.message, { n: safraTemp.idsafraerp }),
                                        true,
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(new Message('alert', e.body.message, true));
                            }
                        } else {
                            this.msgs.push(new Message('error', 'msg-erro-load', true));
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        redirectToList() {
            let tempTela = null;
            let tempAba = null;
            if (this.$route.query.tela == 'retricao-forncedor') {
                //aba de onde veio
                tempTela = 'agro-cliente-politica-comercial-edit'; // rota da tela que vai voltar
                tempAba = 'agro-safra'; // aba da tela que retorna
            } else if (this.$route.query.tela == 'agro-niveltecnologico-new') {
                tempTela = this.$route.query.tela;
            } else if (this.$route.query.tela == 'agro-niveltecnologico-edit') {
                tempTela = this.$route.query.tela;
            } else {
                tempTela = `${this.abrev}-safra`;
            }
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: { id: this.$route.query['id'] },
                    query: { abaSelecionada: tempAba },
                });
            }, 1000);
        },
        redirectToPage() {
            this.$router.push({
                name: `${this.abrev}-safra-edit`,
                params: { id: this.safra.id, descricao: this.safra.descricao },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
    .nome-input {
        width: 49.5%;
    }
    .razao-social-input {
        width: 49.5%;
    }
}
</style>
